import { FormattedMessage, injectIntl, IntlShape } from "react-intl";
import { Field } from "redux-form/immutable";
import UpReduxFormInput from "../../../../../components/up-redux-form-input";

type UsernamePasswordFormComponentProps = {
  authKeyVisible: boolean;
  integrationType: string;
  intl: IntlShape;
};

const UsernamePasswordFormComponent = (props: UsernamePasswordFormComponentProps) => (
  <div style={{ marginTop: "10px" }}>
    <Field
      component={UpReduxFormInput}
      name="username"
      type="text"
      placeholder={props.intl.formatMessage({
        id: `containers.Integrations.${props.integrationType}.username.placeholder`,
        defaultMessage: "Username"
      })}
      label={
        <FormattedMessage
          id={`containers.Integrations.${props.integrationType}.username.label`}
          defaultMessage="Username"
        />
      }
      margin="0 0 10px 0"
    />
    <Field
      component={UpReduxFormInput}
      name="password"
      type="password"
      placeholder={props.intl.formatMessage({
        id: `containers.Integrations.${props.integrationType}.password.placeholder`,
        defaultMessage: "Password"
      })}
      label={
        <FormattedMessage
          id={`containers.Integrations.${props.integrationType}.password.label`}
          defaultMessage="Password"
        />
      }
      margin="0 0 0 0"
    />
    {props.authKeyVisible && (
      <Field
        component={UpReduxFormInput}
        name="authKey"
        type="text"
        placeholder={props.intl.formatMessage({
          id: `containers.Integrations.${props.integrationType}.authKey.placeholder`,
          defaultMessage: "Authentication key"
        })}
        label={
          <FormattedMessage
            id={`containers.Integrations.${props.integrationType}.authKey.label`}
            defaultMessage="Authentication key"
          />
        }
        margin="10px 0 0 0"
      />
    )}
  </div>
);

export const UsernamePasswordForm = injectIntl(UsernamePasswordFormComponent);
